import { Component } from '@angular/core'
import { AutomationEventTypes, AutomationTypes } from '@tokeet-frontend/automations'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { AutomationWizardPanelBaseComponent } from '@tv3/containers/automations/automations-wizard/automation-wizard-panel.component'
import { guestNotificationMessages, userGuestNotificationMessages } from './messages'
import { Actions } from '@ngrx/effects'

@Component({
  selector: 'app-guest-automation-wizard',
  templateUrl: './guest-automation-wizard.component.html',
  styleUrls: ['./guest-automation-wizard.component.scss'],
})
export class GuestAutomationWizardComponent extends AutomationWizardPanelBaseComponent {
  type = AutomationTypes.Guest

  guestNotificationMessages = guestNotificationMessages
  userNotificationMessages = userGuestNotificationMessages

  constructor(protected fb: FormBuilder, protected actions: Actions, protected store: Store<any>) {
    super(actions, store, fb)

    this.form.patchValue({ event: AutomationEventTypes.GuestCreated })
  }
}
